"use client";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import AdminNewSidebar from "components/admin/AdminNewSidebar";
import { Box, Container } from "@mui/material";
import { Header } from "components";
import { Outlet } from "react-router-dom";

const ManageTickets = () => {
  const mdTheme = createTheme();

  return (
    <ThemeProvider theme={mdTheme}>
      <Box className="dashboard-main">
        <AdminNewSidebar />
        <div className="dashboard-section-main">
          <Box
            component="main"
            sx={{
              flexGrow: 1,
              height: "100vh",
              overflow: "auto",
            }}
            className="custom-scroll"
          >
            <div>
              <Header />
              <Container
                sx={{ mt: 4, mb: 4, pb: 16 }}
                // className="adminContainer"
                className="mainContainerComp"
              >
                <Outlet />
                <img
                  src="/assets/images/frameCardBG.png"
                  alt="frameCardBG"
                  style={{
                    position: "absolute",
                    bottom: "-46px",
                    left: "0",
                    width: "296px",
                    pointerEvents: "none",
                  }}
                />
              </Container>
            </div>
          </Box>
        </div>
      </Box>
    </ThemeProvider>
  );
};

export default ManageTickets;
